import { gql } from '@provision/graphql-client';

export const AUTO_GENERATE_SITE_DOCS_FRAGMENT = gql`
  fragment AutoGenerateSiteDocsFields on AutogenerateSiteDocsResult {
    orgNotes
    sitePrimaryEquipmentLocation
    siteNetworkLocation
    site3rdPartyNetworkProvider
    siteWiredNetworkBrand
    siteWirelessNetworkBrand
    siteControlSystemBrand
    siteInternetService
    siteTvServiceProvider
    siteRemoteSystemsManagement
    siteStreamingPlatform
    siteAccessControlSystemSmartLocks
    siteAudioSystemType
    sitePrimaryAudioInterface
    siteVideoSystemType
    siteVideoDistributionBrand
    siteShadeType
    siteShadeInterface
    siteShadeBrand
    siteLightingSystemType
    siteLightingSystemBrand
    sitePhoneSystemType
    sitePhoneSystemBrand
    siteIntercom
    siteSecuritySystemIntegrated
    siteSecuritySystemBrand
    siteCameraSystemType
    siteCameraSystemBrand
    hvacIntegration
    siteHvacBrand
    siteVideoDoorbell
  }
`;
